import React, { Component } from "react";

import {
  CBadge,
  CButton,
  CCol,
  CFormGroup,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSelect,
  CSpinner
} from "@coreui/react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";
import { Node } from "slate";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./style.css";

class Helpdesk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      helpdesks: [],
      text: "",
      loading: true,
      modalFilter: false,
      // action: 0,
      // user: null,
      // origin: 0,
      from: null,
      to: null,
      categories: [],
      groups: [],
      category: "0",
      content: "0",
      group: props.general.active_roles.group_id?.toString() || "0",
      school: props.general.active_roles.school_id?.toString() || "0",
      region: props.general.active_roles.region_id?.toString() || "0",
      room: "0",
      status: "ABERTO",
      mine: false,
      days_from: "0",
      // users: [{ value: null, label: "Carregando" }],
      per_page: 10,
      current_page: 1,
      total_items: null
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ loading: true });

    if (this.props.location.state) {
      this.setState({ ...this.props.location.state });
    } else {
      const obj = {
        text: this.state.text,
        user_id: this.props.user.user.id,
        role_id: this.props.general.active_roles.role_id,
        group_id: parseInt(this.state.group) || null,
        school_id: parseInt(this.state.school) || null,
        region_id: parseInt(this.state.region) || null,
        room_id: parseInt(this.state.room) || null,
        category_id: parseInt(this.state.category) || null,
        content: parseInt(this.state.content) || null,
        status: this.state.status !== "0" ? this.state.status : null,
        mine: this.state.mine,
        from: this.state.from,
        to: this.state.to,
        days_from: this.state.days_from,
        per_page: this.state.per_page,
        page: this.state.current_page,
        newer: true
      };

      axios
        .post(`${URL.api}helpdesk/helpdesk/paginate`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({
            helpdesks: resp.data.data,
            total_items: resp.data.total,
            loading: false
          });
        })
        .catch(error => {
          this.setState({ loading: false });
          this.error("Não foi possível listar as solicitações!");
        });
    }

    axios
      .get(`${URL.api}access/school/listCompleteFilter`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ groups: resp.data.data });
      });

    axios
      .get(`${URL.api}helpdesk/helpdesk/categories`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ categories: resp.data.data });
      });

    // atualiza a lista quando a pagina recarrega
    this.reloadHelpdesks();
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  daysFrom(date) {
    const dt = new Date(date);
    const hj = new Date();

    return Math.floor((hj - dt) / (1000 * 3600 * 24));
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  async reloadHelpdesks(shouldLoad = true) {
    this.setState({ loading: shouldLoad, modalFilter: false });

    const obj = {
      text: this.state.text,
      user_id: this.props.user.user.id,
      role_id: this.props.general.active_roles.role_id,
      group_id: parseInt(this.state.group) || null,
      school_id: parseInt(this.state.school) || null,
      region_id: parseInt(this.state.region) || null,
      room_id: parseInt(this.state.room) || null,
      category_id: parseInt(this.state.category) || null,
      content: parseInt(this.state.content) || null,
      status: this.state.status !== "0" ? this.state.status : null,
      mine: this.state.mine,
      from: this.state.from,
      to: this.state.to,
      days_from: this.state.days_from,
      per_page: this.state.per_page,
      page: this.state.current_page
    };

    try {
      const response = await axios.post(
        `${URL.api}helpdesk/helpdesk/paginate`,
        obj,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      this.setState({
        helpdesks: response.data.data.map(ticket => ({
          ...ticket,
          description: this.serializeSlate(JSON.parse(ticket.description))
        })),
        total_items: response.data.total,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      this.error("Não foi possível listar as solicitações!");
    }
  }

  serializeSlate = slateNodes => slateNodes.map(n => Node.string(n)).join("\n");

  render() {
    const group = this.state.groups.find(
      group => group.id === parseInt(this.state.group)
    );
    const region =
      group &&
      group.regions.find(region => region.id === parseInt(this.state.region));
    const school =
      region &&
      region.schools.find(school => school.id === parseInt(this.state.school));

    return (
      <>
        <div className="animated fadeIn">
          <CRow>
            <Breadcrumb current={this.props.currentRoute} />
            {!this.state.loading ? (
              <div id="list">
                <DataTable
                  responsiveCards
                  list={this.state.helpdesks}
                  title="Helpdesks"
                  subtitle="Veja suas solicitações de helpdesk"
                  pushState={this.state}
                  remote
                  currentPage={this.state.current_page}
                  totalItems={this.state.total_items}
                  perPage={this.state.per_page}
                  onPageChange={page =>
                    this.setState({ current_page: page }, () =>
                      this.reloadHelpdesks(false)
                    )
                  }
                  onSizePerPageList={size =>
                    this.setState({ per_page: size }, () =>
                      this.reloadHelpdesks(false)
                    )
                  }
                  trClassName="cursor"
                  header={[
                    {
                      name: "id",
                      denomination: "Ticket",
                      width: "90px"
                    },
                    {
                      name: "description",
                      denomination: "Solicitação"
                      // dataSort: false
                    },
                    {
                      name: "status",
                      denomination: "Status",
                      width: "7%",
                      dataFormat: (cell, row) => (
                        <CBadge
                          color={cell === "ABERTO" ? "primary" : "secondary"}
                        >
                          {cell}
                        </CBadge>
                      )
                    },
                    {
                      name: "category_name",
                      denomination: "Categoria",
                      width: "13%"
                    },
                    {
                      name: "user_name",
                      denomination: "Usuário",
                      width: "13%",
                      dataFormat: (cell, row) => (
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              URL.img +
                              (row.user_photo ||
                                "uploads/users/profileEmpty.jpg")
                            }
                            className="rounded-circle mr-2"
                            style={{ height: "20px", width: "20px" }}
                          />
                          {cell}
                        </div>
                      )
                    },
                    {
                      name: "last_comment_created_at",
                      denomination: "Data da última mensagem",
                      width: "17%",
                      // dataSort: false,
                      dataFormat: (cell, row) =>
                        this.friendlyDate(cell || row.created_at)
                    },
                    {
                      name: "created_at",
                      denomination: "Informações",
                      width: "14%",
                      dataFormat: (cell, row) => {
                        const days = this.daysFrom(cell);
                        if (row.status === "ABERTO") {
                          return (
                            <div>
                              {days > 5 ? (
                                <i className="fa fa-warning text-danger mr-2"></i>
                              ) : days > 2 ? (
                                <i className="fa fa-warning text-warning mr-2"></i>
                              ) : (
                                <i className="fa fa-info-circle text-muted mr-2"></i>
                              )}
                              {`Aberto há ${days} dias`}
                            </div>
                          );
                        }

                        return (
                          <div>
                            <i className="fa fa-check-square text-success mr-2"></i>
                            Finalizado
                          </div>
                        );
                      }
                    }
                  ]}
                  path="/helpdesk/"
                  extraComponent={
                    <CButton
                      color="primary"
                      className="ml-2"
                      onClick={() => this.setState({ modalFilter: true })}
                    >
                      <i className="fa fa-filter mr-2"></i>Filtrar
                    </CButton>
                  }
                />
              </div>
            ) : (
              <div className="w-100 d-flex justify-content-center">
                <CSpinner size="sm" color="secondary" />
              </div>
            )}
          </CRow>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </div>
        <CModal
          show={this.state.modalFilter}
          onClose={() => this.setState({ modalFilter: false })}
          size="lg"
          centered
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle className="mb-0">Filtrar solicitações</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CFormGroup>
              <CLabel>Pesquisar</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CInput
                  value={this.state.text}
                  onChange={e => this.setState({ text: e.target.value })}
                  placeholder="Pesquisar"
                />
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Grupo</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.group}
                  onChange={e =>
                    this.setState({
                      group: e.target.value,
                      region: "0",
                      school: "0",
                      room: "0"
                    })
                  }
                  disabled={this.props.general.active_roles.group_id !== null}
                >
                  <option value={0}>Todos</option>
                  {this.state.groups.map(group => (
                    <option value={group.id} key={group.id}>
                      {group.name}
                    </option>
                  ))}
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Regional</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.region}
                  onChange={e =>
                    this.setState({
                      region: e.target.value,
                      school: "0",
                      room: "0"
                    })
                  }
                  disabled={this.props.general.active_roles.region_id !== null}
                >
                  <option value={0}>Todas</option>
                  {group?.regions.map(region => (
                    <option value={region.id} key={region.id}>
                      {region.name}
                    </option>
                  ))}
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Escola</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.school}
                  onChange={e =>
                    this.setState({ school: e.target.value, room: "0" })
                  }
                  disabled={this.props.general.active_roles.school_id !== null}
                >
                  <option value={0}>Todas</option>
                  {region?.schools.map(school => (
                    <option value={school.id} key={school.id}>
                      {school.name}
                    </option>
                  ))}
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Turma</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.room}
                  onChange={e => this.setState({ room: e.target.value })}
                >
                  <option value={0}>Todas</option>
                  {school?.rooms.map(room => (
                    <option value={room.id} key={room.id}>
                      {room.name}
                    </option>
                  ))}
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Status</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.status}
                  onChange={e => this.setState({ status: e.target.value })}
                >
                  <option value={0}>Todos</option>
                  <option value="ABERTO">Aberto</option>
                  <option value="FECHADO">Fechado</option>
                </CSelect>
              </CInputGroup>
            </CFormGroup>
            <CFormGroup>
              <CRow>
                <CCol>
                  <div className="mb-2">Categoria</div>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      value={this.state.category}
                      onChange={e =>
                        this.setState({ category: e.target.value })
                      }
                    >
                      <option value={0}>Todas</option>
                      {this.state.categories.map(category => (
                        <option value={category.id} key={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </CCol>
                <CCol>
                  <div className="mb-2">Solicitações de conteúdo</div>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-text-width"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      value={this.state.content}
                      onChange={e => this.setState({ content: e.target.value })}
                    >
                      <option value={0}>Ambos</option>
                      <option value={1}>Apenas solicitações de conteúdo</option>
                      <option value={2}>
                        Apenas solicitações da plataforma
                      </option>
                    </CSelect>
                  </CInputGroup>
                </CCol>
              </CRow>
            </CFormGroup>
            <CFormGroup>
              <CRow>
                <CCol>
                  <div className="mb-2">Início</div>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-clock-o"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Form.Control
                      type="datetime-local"
                      value={this.state.from}
                      step="1"
                      onChange={e => this.setState({ from: e.target.value })}
                    />
                  </CInputGroup>
                </CCol>
                <CCol>
                  <div className="mb-2">Fim</div>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-clock-o"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <Form.Control
                      type="datetime-local"
                      value={this.state.to}
                      step="1"
                      onChange={e => this.setState({ to: e.target.value })}
                    />
                  </CInputGroup>
                </CCol>
              </CRow>
            </CFormGroup>
            <CFormGroup>
              <CLabel>Aberto</CLabel>
              <CInputGroup>
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-text-width"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.days_from}
                  onChange={e => this.setState({ days_from: e.target.value })}
                >
                  <option value={0}>Em qualquer momento</option>
                  <option value={2}>Há mais de 2 dias</option>
                  <option value={5}>Há mais de 5 dias</option>
                </CSelect>
              </CInputGroup>
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
            <CButton color="primary" onClick={() => this.reloadHelpdesks()}>
              Filtrar
            </CButton>
          </CModalFooter>
          <ProtectedRoute routeId={this.props.currentRoute} />
        </CModal>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj,
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Helpdesk);
